import { print } from "graphql";
import {
  Pedido,
  PagePedidoInput,
  PayloadCreatePedido,
  PayloadCreateRenovacaoCRLV,
  PayloadCreateCompany,
  PayloadRenovacaoCertificadoTacografo,
} from "@/models/pedido";
import { BaseAPI } from "@/api/base.api";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { Pagination } from "./pagination";
import { map } from "rxjs/operators";
import { InputUpoloadDocumento } from "@/models/documento";

const pedidoPage = require("@/query/pedido/Page.graphql");
const pedidoShow = require("@/query/pedido/Show.graphql");

import {
  PayloadInclusaoVeiculo,
  PayloadEnvioDocumentacaoSeguro,
} from "@/models/veiculo";
import {
  PayloadAutoVistoria,
  PayloadLaudoEngenheiroMecanico,
  PayloadRenovacaoCadastroEmpresa,
} from "@/models/company";

export class PedidoAPI extends BaseAPI<Pedido> {
  private apiUrlPayments: string;
  constructor() {
    super();
    this.backUrl = `${this.backUrl}/solicitations`;
    this.apiUrl = `${this.apiUrl}/api_app/v1`;
  }

  public createPedido(body: PayloadCreatePedido): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}`, { ...body });
  }

  public createRenovacaoCrlv(
    body: PayloadCreateRenovacaoCRLV
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/renovacao-crlv`, { ...body });
  }

  public createCompany(body: PayloadCreateCompany): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/cadastro-empresa`, { ...body });
  }

  public inclusaoVeiculo(
    body: PayloadInclusaoVeiculo
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/inclusao-veiculo`, { ...body });
  }

  public exclusaoVeiculo(
    body: PayloadInclusaoVeiculo
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/exclusao-veiculo`, { ...body });
  }

  public criarAutoVistoria(body: PayloadAutoVistoria): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/autovistoria`, { ...body });
  }

  public renovacaoCertificadoTacografo(
    body: PayloadRenovacaoCertificadoTacografo
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/renovacao-certificado-tacografo`, {
      ...body,
    });
  }

  public criarLaudoEngenheiroMecanico(
    body: PayloadLaudoEngenheiroMecanico
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/laudo-engenheiro-mecanico`, {
      ...body,
    });
  }

  public criarEnvioDocumentacaoSeguro(
    body: PayloadEnvioDocumentacaoSeguro
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/envio-documentacao-seguro`, {
      ...body,
    });
  }

  public criarRenovacaoCadastroEmpresa(
    body: PayloadRenovacaoCadastroEmpresa
  ): AxiosObservable<Pedido> {
    return this.axios.post(`${this.backUrl}/renovacao-cadastro-empresa`, {
      ...body,
    });
  }

  public uploadDocument(
    pedidoID: number,
    body: InputUpoloadDocumento
  ): AxiosObservable<any> {
    let formData = new FormData();
    formData.append("file", body.file);
    formData.append("type", body.type);
    // formData.append("dateOfIssue", body.dateOfIssue);
    // formData.append("dateExpiration", body.dateExpiration);
    // formData.append("agencyShipping", body.agencyShipping);
    // formData.append("code", body.code);

    return this.axios.post(
      `${this.backUrl}/${pedidoID}/uploadDocument`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        // onUploadProgress: ({total, loaded}) => {
        //   const percentage = Math.round((loaded * 100) / total)
        //   store.commit('cadastroEmpresa/SET_DOCUMENT_FORM',{typeDocumentKey: body.typeDocumentKey, doc: {progress: percentage}})
        // }
      }
    );
  }

  public createPedidos(body: object): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/solicitations/bulks/autovistoria`, body);
  }

  public detailsPedidos(group: string): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/solicitations/?group=${group}`);
  }

  public detailsPedidosByGroup(group: string): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/solicitations/?group=${group}`);
  }

  public detailsListPayments(group: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/payments/?solicitation_group=${group}`
    );
  }

  public updateEvidences(key: string, formData: object) {
    return this.axios.patch(`${this.apiUrl}/requirements/${key}`, formData)
  }

  public upload(key: string, formData: object) {
    return this.axios.post(`${this.apiUrl}/requirements/${key}/upload`, formData)
  }

  public getByKey(key: string) {
    return this.axios.get(`${this.apiUrl}/requirements/${key}`)
  }

  public contentDetach(key: string) {
    return this.axios.delete(`${this.apiUrl}/requirements/${key}/content_detach`)
  }

  public list(params: any): AxiosObservable<Pedido[]> {
    return this.axios.get(`${this.apiUrl}/solicitations`, { params: this.buildFiltered(params) })
  }

  public listStatus(): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/solicitations/statuses`);
  }

  public show(id: number): AxiosObservable<Pedido> {
    return this.axios.get(`${this.apiUrl}/solicitations/${id}`);
  }

  public showPaymentsGroup(group: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/payments/?solicitation_group=${group}`
    );
  }

  public createAutovistoria(
    solicitaionId: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections`,
      body
    );
  }
  public getAllAutovistoria(solicitaionId: string): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections`
    );
  }
  public detailsAutovistoria(
    key: string
  ): AxiosObservable<any> {
    return this.axios.get(
      `${this.apiUrl}/inspections/${key}`
    );
  }
  public updateApproveImages(
    solicitaionId: string,
    inspectionKey: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/requirements/${key}`,
      body
    );
  }
  public updateVehicleInformation(
    solicitaionId: string,
    inspectionKey: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/vehicles/${key}`,
      body
    );
  }
  public deferAutovistoria(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/defer`
    );
  }
  public denyAutovistoria(
    solicitaionId: string,
    key: string,
    reject_reason: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/deny`, { reject_reason }
    );
  }
  public updateItemChecklist(
    solicitaionId: string,
    inspectionKey: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/checklist_items/${key}`,
      body
    );
  }

  public finishChecklist(
    solicitaionId: string,
    inspectionKey: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${inspectionKey}/checklist/${key}/finish`
    );
  }

  public resendAutovistoria(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/resend`
    );
  }

  public sendEvidenceRefusend(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/send_refuseds`
    );
  }

  public updateAutovistoria(
    solicitaionId: string,
    key: string,
    body: object
  ): AxiosObservable<any> {
    return this.axios.patch(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}`,
      body
    );
  }

  public generateReport(
    solicitaionId: string,
    key: string
  ): AxiosObservable<any> {
    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/reports/generate_original`
    );
  }

  public uploadReport(
    solicitaionId: string,
    key: string,
    content: File
  ): AxiosObservable<any> {

    let formData = new FormData();
    formData.append("content", content);

    return this.axios.post(
      `${this.apiUrl}/solicitations/${solicitaionId}/inspections/${key}/reports/upload_signed`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );
  }

  public cancel(id: number, reason: string): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/cancel`, { reason });
  }

  public analyse(id: number): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/analyze`);
  }

  public approve(id: number): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/approve`);
  }

  public refuse(id: number, reason: string): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/refuse`, { reason });
  }

  public pending(id: number): AxiosObservable<any> {
    return this.axios.patch(`${this.apiUrl}/solicitations/${id}/pending`);
  }

  public listDocuments(orderId: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/solicitations/${orderId}/documents`);
  }

  public listDocumentsPublic(orderId: number): AxiosObservable<any> {
    return this.axios.get(`${this.apiUrl}/public/solicitations/${orderId}/documents`);
  }
}
